(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (function () {
    var tracks = document.querySelectorAll('[data-announcement-track]');
    tracks.forEach(function (track) {
      var messages = track.querySelectorAll('.announcement-bar__message');
      if (messages.length < 2) return;
      var interval = parseInt(track.getAttribute('data-interval') || '4000', 10);
      if (isNaN(interval) || interval < 1500) interval = 4000;
      var idx = 0;
      var timer = null;

      function show(nextIdx) {
        messages[idx].classList.remove('is-active');
        idx = (nextIdx + messages.length) % messages.length;
        messages[idx].classList.add('is-active');
      }

      function start() {
        if (timer) clearInterval(timer);
        timer = setInterval(function () {
          show(idx + 1);
        }, interval);
      }

      var parent = track.parentElement;
      var prevBtn = parent ? parent.querySelector('[data-announcement-prev]') : null;
      var nextBtn = parent ? parent.querySelector('[data-announcement-next]') : null;

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          show(idx - 1);
          start();
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          show(idx + 1);
          start();
        });
      }

      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var form = document.querySelector('[data-cart-form]');
    if (!form) return;

    form.addEventListener('click', function (e) {
      var dec = e.target.closest('[data-quantity-decrease]');
      var inc = e.target.closest('[data-quantity-increase]');
      if (!dec && !inc) return;

      var wrap = (dec || inc).closest('[data-quantity]');
      if (!wrap) return;
      var input = wrap.querySelector('[data-quantity-input]');
      if (!input) return;

      var current = parseInt(input.value || '0', 10);
      if (isNaN(current)) current = 0;
      var next = dec ? Math.max(0, current - 1) : current + 1;
      input.value = next;

      form.submit();
    });

    // Auto-submit when typing directly into the quantity input.
    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-quantity-input]')) {
        form.submit();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var menu = document.getElementById('site-menu');
    var overlay = document.getElementById('site-menu-overlay');
    var _scrollY = 0;

    window.closeMenuNow = function () {
      if (!menu) return;
      menu.style.display = 'none';
      if (overlay) overlay.style.display = 'none';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      window.scrollTo(0, _scrollY);
    };

    function openMenu() {
      if (!menu) return;
      _scrollY = window.pageYOffset || window.scrollY || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + _scrollY + 'px';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      menu.style.display = 'flex';
      if (overlay) overlay.style.display = 'block';
      updateArrows();
    }

    var menuBtn = document.querySelector('[data-menu-open]');
    var closeBtn = document.querySelector('[data-menu-close]');
    if (menuBtn) menuBtn.addEventListener('click', openMenu);
    if (closeBtn) closeBtn.addEventListener('click', closeMenuNow);
    if (overlay) overlay.addEventListener('click', closeMenuNow);

    /* Accordéon */
    document.querySelectorAll('[data-submenu-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.site-menu__item');
        var sub = item.querySelector('.site-menu__sublist');
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (open) { sub.setAttribute('hidden', ''); } else { sub.removeAttribute('hidden'); }
      });
    });

    /* Carousel flèches */
    var track = document.getElementById('smr-track');
    var btnPrev = document.getElementById('smr-prev');
    var btnNext = document.getElementById('smr-next');

    function updateArrows() {
      if (!track || !btnPrev || !btnNext) return;
      var atStart = track.scrollLeft <= 4;
      var atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
      btnPrev.classList.toggle('hidden', atStart);
      btnNext.classList.toggle('hidden', atEnd);
    }

    function scrollBy(dir) {
      if (!track) return;
      var card = track.querySelector('.smr__card');
      var step = card ? card.offsetWidth + 10 : 120;
      track.scrollBy({ left: dir * step, behavior: 'smooth' });
    }

    if (btnPrev) btnPrev.addEventListener('click', function () { scrollBy(-1); });
    if (btnNext) btnNext.addEventListener('click', function () { scrollBy(1); });
    if (track) track.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    var root = document.currentScript ? document.currentScript.closest('.shopify-section') : document;
    if (!root) root = document;

    var section = root.querySelector('.product-section');
    if (!section) return;

    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;

    var productData;
    try {
      productData = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var variants = productData.variants || [];
    var moneyFormat = productData.moneyFormat || '${{amount}}';
    var strings = productData.strings || {};

    var variantInput = section.querySelector('[data-variant-input]');
    var priceEl = section.querySelector('[data-product-price]');
    var atcBtn = section.querySelector('[data-atc-button]');
    var atcLabel = section.querySelector('[data-atc-label]');
    var pillsEl = section.querySelector('[data-variant-pills]');

    function formatMoney(cents) {
      var value = (cents / 100).toFixed(2);
      return moneyFormat
        .replace(/\{\{\s*amount\s*\}\}/g, value.replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.floor(cents / 100))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, Math.floor(cents / 100));
    }

    function updatePrice(variant) {
      if (!priceEl || !variant) return;
      var html = '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html =
          '<span class="product-section__price-sale">' +
          formatMoney(variant.price) +
          '</span>' +
          '<s class="product-section__price-compare">' +
          formatMoney(variant.compare_at_price) +
          '</s>';
      } else {
        html = '<span>' + formatMoney(variant.price) + '</span>';
      }
      priceEl.innerHTML = html;
    }

    function updateAtc(variant) {
      if (!atcBtn || !atcLabel || !variant) return;
      if (variant.available) {
        atcBtn.disabled = false;
        atcLabel.textContent = strings.addToCart || 'Add to cart';
      } else {
        atcBtn.disabled = true;
        atcLabel.textContent = strings.soldOut || 'Sold out';
      }
    }

    function updateGallery(variant) {
      // Scroll the slides container to the slide whose img matches the variant featured_image.
      if (!variant || !variant.featured_image) return;
      var slidesContainer = section.querySelector('[data-gallery-slides]');
      if (!slidesContainer) return;
      var slides = section.querySelectorAll('[data-gallery-slide]');
      if (!slides.length) return;
      var targetSrc = variant.featured_image.src;
      if (!targetSrc) return;
      var targetKey = targetSrc.split('?')[0].split('/').pop().split('.')[0];
      for (var i = 0; i < slides.length; i++) {
        var img = slides[i].querySelector('img');
        if (!img || !img.src) continue;
        var key = img.src.split('?')[0].split('/').pop().split('.')[0];
        if (key === targetKey) {
          slidesContainer.scrollTo({ left: i * slidesContainer.clientWidth, behavior: 'smooth' });
          break;
        }
      }
    }

    if (pillsEl) {
      var selectEls = pillsEl.querySelectorAll('[data-variant-select]');

      function onVariantChange() {
        var selectedValues = [];
        selectEls.forEach(function (s) {
          var idx = parseInt(s.getAttribute('data-option-index') || '0', 10);
          selectedValues[idx] = s.value;
        });

        var variant = null;
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          if (!v.options) continue;
          var match = true;
          for (var j = 0; j < selectedValues.length; j++) {
            if (v.options[j] !== selectedValues[j]) {
              match = false;
              break;
            }
          }
          if (match) {
            variant = v;
            break;
          }
        }

        selectEls.forEach(function (s) {
          var idx = s.getAttribute('data-option-index');
          var span = pillsEl.querySelector('[data-pills-selected="' + idx + '"]');
          if (span) span.textContent = (s.value == null ? '' : s.value);
        });

        if (variant) {
          if (variantInput) variantInput.value = variant.id;
          updatePrice(variant);
          updateAtc(variant);
          updateGallery(variant);

          if (history.replaceState) {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            history.replaceState({}, '', url.toString());
          }
        }
      }

      selectEls.forEach(function (s) {
        s.addEventListener('change', onVariantChange);
      });
    }

    var stickyPrice = section.querySelector('[data-sticky-price]');

    function updateStickyPrice(variant) {
      if (!stickyPrice || !variant) return;
      stickyPrice.textContent = formatMoney(variant.price);
    }

    var originalUpdatePrice = updatePrice;
    updatePrice = function (variant) {
      originalUpdatePrice(variant);
      updateStickyPrice(variant);
    };

    var qtyWrap = section.querySelector('[data-quantity-selector]');
    if (qtyWrap) {
      var qtyInput = qtyWrap.querySelector('[data-quantity-input]');
      var qtyDec = qtyWrap.querySelector('[data-quantity-decrease]');
      var qtyInc = qtyWrap.querySelector('[data-quantity-increase]');

      function setQty(next) {
        if (!qtyInput) return;
        var min = parseInt(qtyInput.min || '1', 10);
        if (isNaN(next) || next < min) next = min;
        qtyInput.value = next;
      }

      if (qtyDec) {
        qtyDec.addEventListener('click', function () {
          setQty(parseInt(qtyInput.value || '1', 10) - 1);
        });
      }
      if (qtyInc) {
        qtyInc.addEventListener('click', function () {
          setQty(parseInt(qtyInput.value || '1', 10) + 1);
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
